import script from "./TournamentCheckin.vue?vue&type=script&setup=true&lang=js"
export * from "./TournamentCheckin.vue?vue&type=script&setup=true&lang=js"

import "./TournamentCheckin.vue?vue&type=style&index=0&id=c24d62b8&lang=css"

const __exports__ = script;

export default __exports__